import {FormSection, ShippingConfigurationTabs} from "../../../ui";
import {ShippingConfigConstruct} from "../../../../api";


interface CmsShippingOptionConfigurationFormProps {
    saving: boolean
    loading: boolean
    value: ShippingConfigConstruct
    onChange: (val: ShippingConfigConstruct) => any
    validate: () => any
    selectClientOptions: { label: string, value: string }[]
    validationFor: (p: string) => string | undefined
}

const CmsShippingOptionConfigurationForm = function CmsShippingOptionConfigurationForm({
                                                                                           value,
                                                                                           saving,
                                                                                           loading,
                                                                                           selectClientOptions,
                                                                                           onChange,
                                                                                           validate,
                                                                                           validationFor
                                                                                       }: CmsShippingOptionConfigurationFormProps) {

    return <FormSection
        header={<strong>Versandmandanten</strong>}
        label={""}>
        <>
                    <ShippingConfigurationTabs
                        disabled={saving || loading}
                        clientOptions={selectClientOptions}
                        value={value}
                        onChange={(value: ShippingConfigConstruct) => {
                            onChange(value)
                        }}
                        onBlur={() => validate()}
                        validationFor={(k) => validationFor(k)}
                    />
        </>
    </FormSection>
}

export {
    CmsShippingOptionConfigurationForm
}
